<template>
  <div class="col-xl-12">
    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
        <div class="card small-widget">
          <div class="card-body primary">
            <span class="f-light">Active Distributors</span>
            <div class="d-flex align-items-end gap-1">
              <h4>{{ distributorActiveCount }}</h4>
              <span class="font-primary f-12 f-w-500"></span>
            </div>
            <div class="card-icon third-card">
              <i class="fa-solid fa-people-group third-icon"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
        <div class="card small-widget">
          <div class="card-body secondary">
            <span class="f-light">Dealers + Com</span>
            <div class="d-flex align-items-end gap-1">
              <h4>{{ dealerActiveCount }}</h4>
              <span class="font-secondary f-12 f-w-500"></span>
            </div>
            <div class="card-icon first-card">
              <i class="fa-solid fa-handshake first-icon"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
        <div class="card small-widget">
          <div class="card-body success">
            <span class="f-light">Onboarded Dealers</span>
            <div class="d-flex align-items-end gap-1">
              <h4>{{ dealerOnboardedCount }}</h4>
              <span class="font-success f-12 f-w-500"></span>
            </div>
            <div class="card-icon second-card">
              <i class="fa-solid fa-user-group second-icon"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
        <div class="card small-widget">
          <div class="card-body warning">
            <span class="f-light">Active Sales Reps</span>
            <div class="d-flex align-items-end gap-1">
              <h4>{{ dsrActiveCount }}</h4>
              <span class="font-warning f-12 f-w-500"></span>
            </div>
            <div class="card-icon fourth-card">
              <i class="fa-solid fa-bullseye fourth-icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchDashboardCounts } from '@/services/dataService';

export default {
  data() {
    return {
      token: localStorage.getItem('token_set'),
      profileId: localStorage.getItem('profile_id'),
      activeItemsCount: "",
      fsmActiveCount: "",
      asmActiveCount: "",
      distributorActiveCount: "",
      seActiveCount: "",
      dsrActiveCount: "",
      dealerActiveCount: "",
      dealerOnboardedCount: "",
    };
  },

  mounted() {
    // Call fetchData automatically when the component is mounted
    this.fetchData();

    // this.fetchDataUnderUser();
  },

  methods: {
    async fetchData() {
      try {
        const response = await fetchDashboardCounts(this.token, this.profileId);

        if(response.data.status === "success") {
          // Update component's data with API response values
          const data = response.data.data;
          this.activeItemsCount = data.activeItemsCount;
          this.fsmActiveCount = data.fsmActiveCount;
          this.asmActiveCount = data.asmActiveCount;
          this.distributorActiveCount = data.distributorActiveCount;
          this.seActiveCount = data.seActiveCount;
          this.dsrActiveCount = data.dsrActiveCount;
          this.dealerActiveCount = data.dealerActiveCount;
          this.dealerOnboardedCount = data.dealerOnboardedCount;
        } else {
          console.error("Failed to fetch data: ", response.data.message);
        }
      } catch (e) {
        console.error(e);
      }
    },
  }
};
</script>

<style scoped>
/* Spinner styles */
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px; /* Adjust the height to fit the design */
}

.spinner {
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top: 2px solid #000; /* Spinner color */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Additional responsive styles */
@media (max-width: 768px) {
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

.card-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  position: absolute;
  top: 15px;
  right: -10px;
}

.card-icon i {
  font-size: 24px;
}

.first-card {
  background: radial-gradient(circle, rgba(255, 182, 193, 0.1), rgba(255, 182, 193, 0.2));
}

.second-card {
  background: radial-gradient(circle, rgba(173, 216, 230, 0.1), rgba(173, 216, 230, 0.2));
}

.third-card{
  background: radial-gradient(circle, rgba(144, 238, 144, 0.1), rgba(144, 238, 144, 0.2));
}

.fourth-card {
  background: radial-gradient(circle, rgba(255, 255, 153, 0.1), rgba(254, 230, 113, 0.2));
}

.first-icon {
  color: rgba(255, 182, 193, 1); /* Light Pink */
}

.second-icon {
  color: rgba(173, 216, 230, 1); /* Light Blue */
}

.third-icon {
  color: rgba(144, 238, 144, 1); /* Light Green */
}

.fourth-icon {
  color: rgba(254, 230, 113, 1); /* Light Yellow */
}

</style>
